"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrategicOverviewCopyToBiddingParamsSchema = void 0;
const zod_1 = require("zod");
/**
 * Schema describing the parameters of copying Strategic Overview / Allocation data
 * into Bidding / Strategic (strategicVolumeReport).
 */
exports.StrategicOverviewCopyToBiddingParamsSchema = zod_1.z.object({
    versionId: zod_1.z.number().int().positive(),
    workingUnitIds: zod_1.z.number().int().positive().array().optional(),
    startMonth: zod_1.z.string().regex(/^\d{4}-\d{2}$/),
    endMonth: zod_1.z.string().regex(/^\d{4}-\d{2}$/),
});
